import React from 'react';
import { Redirect, matchPath } from 'react-router-dom';

// Keep bookmarked URLs usable while routing them through current Admin flows.
export const legacyAdminRoutes = [
  { path: '/category', target: () => '/categories' },
  { path: '/addCategory', target: () => '/categories/add' },
  { path: '/editCategory/:id', target: ({ id }) => `/categories/edit/${id}` },
  { path: '/:category/AddSubCategory', target: () => '/sub-categories/add', state: ({ category }) => ({ categoryId: category }) },
  { path: '/:category/:id/EditSubCategory', target: ({ id }) => `/sub-categories/edit/${id}` },
  { path: '/:data/SubFirst', target: () => '/sub-categories' },
  { path: '/AddCategoryField', target: () => '/fields/add' },
];

export function currentAdminLocation(location) {
  for (const route of legacyAdminRoutes) {
    const match = matchPath(location.pathname, { path: route.path, exact: true });
    if (match) return {
      pathname: route.target(match.params),
      search: location.search,
      hash: location.hash,
      state: { ...location.state, ...route.state?.(match.params) },
    };
  }
  return null;
}

export default function LegacyAdminRedirect({ location }) {
  const destination = currentAdminLocation(location);
  return destination ? <Redirect to={destination} /> : null;
}
